export default function prettyNumberWithSpaces(x: number){
  return x.toFixed().toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, " ")
}
